import { useNuxtApp } from "#app"; // 导入 `useNuxtApp`
import { $fetch as ofetch } from "ofetch";
import {
  getMallAppToken,
  getMallApiBaseUrlFromStoredStoreInformation,
  isDisabledMallSsr,
} from "@/utils/globalData"; // 导入 `useNuxtApp`

function makeEarlyDirectMallRequest(url, body) {
  if (!process.client || !isDisabledMallSsr()) {
    return null;
  }

  const mallApiBaseUrl = getMallApiBaseUrlFromStoredStoreInformation();
  if (!mallApiBaseUrl) {
    return null;
  }

  return ofetch(url, {
    method: "POST",
    body,
    baseURL: mallApiBaseUrl,
    headers: {
      authorization: body?.unhaveToken ? "" : (getMallAppToken() || ""),
    },
  });
}
/**
 * 获取当前用户信息
 * @param params
 * @returns {*}
 */
export function getCurrentUserData(body, $fetch, headers) {
  
  return useNuxtApp().$customFetch(
    "../collectionSite/mall/portal/user/queryCurrentUser?collection=1",
    { method: "POST", body }
  );
}


/**
 * 获取当前商城用户信息
 * @param params
 * @returns {*}
 */
export function getCurrentMallUserData(body, $fetch, headers) {
  const earlyDirectRequest = makeEarlyDirectMallRequest(
    "/mall/portal/auth/loginTourists?mall=1",
    body,
  );
  if (earlyDirectRequest) {
    return earlyDirectRequest;
  }

  return useNuxtApp().$customFetch(
    "/mallSite/portal/auth/loginTourists?mall=1",
    { method: "POST", body }
  );
}
/**
 * 翻译数据
 * @param params
 * @returns {*}
 */
export function alibabaProductTextTranslate(body, $fetch, headers) {
  const oldParam = body?.param || {}
  const texts = Array.isArray(body?.texts)
    ? body.texts
    : String(oldParam.sourceTextList || '')
      .split('\n')
      .map(item => item.trim())
      .filter(Boolean)
  return useNuxtApp().$customFetch(
    "/apph5/customer-api/translate/batch?hiddenErrTip=1&uncheck401=1",
    {
      method: "POST",
      body: {
        isSystemText: typeof body?.isSystemText === 'number' ? body.isSystemText : 0,
        texts,
        sourceLanguage: body?.sourceLanguage || oldParam.sourceLanguage || 'zh',
        targetLanguage: body?.targetLanguage || oldParam.targetLanguage || 'en',
        appType: body?.appType || 'react-mall-app',
      },
    }
  );
}





/**
 * 获取当前汇率 币种
 * @param params
 * @returns {*}
 */
export function getCurrencyDataList(body, $fetch, headers) {
  
  return useNuxtApp().$customFetch(
     "../collectionSite/mall/admin/dealerShop/dealerShopDetailByPass?collection=1&uncheck401=1&getCache=1",
   // "../collectionSite/portal/dealerShopCurrencyRate/queryPageList?collection=1",
    { method: "POST", body }
  );
}
